(() => {
'use strict';
class ProductTabs extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    const signal = this.controller.signal;
    this.tabs = Array.from(this.querySelectorAll('[role="tab"]')).filter((tab) => tab.closest('product-tabs') === this);
    this.addEventListener('click', (event) => {
      const tab = event.target.closest('[role="tab"]');
      if (tab && this.tabs.includes(tab)) this.select(tab);
    }, { signal });
    this.addEventListener('keydown', (event) => {
      if (!this.tabs.includes(event.target)) return;
      const index = this.tabs.indexOf(event.target);
      let target;
      if (event.key === 'ArrowRight') target = this.tabs[(index + 1) % this.tabs.length];
      if (event.key === 'ArrowLeft') target = this.tabs[(index + this.tabs.length - 1) % this.tabs.length];
      if (event.key === 'Home') target = this.tabs[0];
      if (event.key === 'End') target = this.tabs[this.tabs.length - 1];
      if (target) { event.preventDefault(); this.select(target); target.focus(); }
    }, { signal });
  }
  disconnectedCallback() { this.controller?.abort(); }
  select(selected) {
    this.tabs.forEach((tab) => {
      const active = tab === selected;
      tab.setAttribute('aria-selected', String(active));
      tab.tabIndex = active ? 0 : -1;
      const panel = document.getElementById(tab.getAttribute('aria-controls'));
      if (panel) panel.hidden = !active;
    });
  }
}
if (!customElements.get('product-tabs')) customElements.define('product-tabs', ProductTabs);

})();
